export const caseStudyRowCss =
  "w-screen md:w-auto px-8 overflow-x-auto items-start mb-16"
